import * as LabelPrimitive from '@radix-ui/react-label';
import type { FC, ReactNode } from 'react';

interface FormFieldProps {
  label: string;
  htmlFor: string;
  error?: string;
  children: ReactNode;
}

const FormField: FC<FormFieldProps> = ({ label, htmlFor, error, children }) => (
  <div className="flex flex-col gap-1.5">
    <LabelPrimitive.Root
      htmlFor={htmlFor}
      className="text-sm font-medium text-[var(--color-ink-muted)]"
    >
      {label}
    </LabelPrimitive.Root>
    {children}
    {error ? <p className="text-xs text-[var(--color-danger-ink)]">{error}</p> : null}
  </div>
);

export default FormField;
